'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _epics = require('./epics');

var _epics2 = _interopRequireDefault(_epics);

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxObservable = require('redux-observable');

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QA = function () {
  return _enviro2.default.getShort() === 'qa';
}();

exports.default = function (history) {
  var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var router = (0, _reactRouterRedux.routerMiddleware)(history);
  var epic = (0, _reduxObservable.createEpicMiddleware)(_epics2.default);
  var enhancer = (0, _redux.applyMiddleware)(router, epic);
  if ((QA || localStorage && localStorage.getItem('REDUX_DEVTOOLS')) && window.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancer = (0, _redux.compose)(enhancer, window.__REDUX_DEVTOOLS_EXTENSION__());
  }
  return (0, _redux.createStore)(_reducers2.default, init, enhancer);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/store.js
// module id = 407
// module chunks = 177